/**
 * Listen for trainer session-end broadcast on the LiveKit data channel.
 */

import { useEffect } from "react";
import { useMaybeRoomContext } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";
import { decodeLiveSessionEnded } from "./liveSessionEndSync";

type Args = {
  enabled?: boolean;
  onSessionEnded?: () => void;
};

export function useLiveSessionEndSync({
  enabled = true,
  onSessionEnded,
}: Args): void {
  const room = useMaybeRoomContext();

  useEffect(() => {
    if (!enabled || !room || !onSessionEnded) return;

    const onData = (
      payload: Uint8Array,
      _participant?: unknown,
      _kind?: unknown,
      topic?: string,
    ) => {
      void topic;
      const msg = decodeLiveSessionEnded(payload);
      if (msg) onSessionEnded();
    };

    room.on(RoomEvent.DataReceived, onData);
    return () => {
      room.off(RoomEvent.DataReceived, onData);
    };
  }, [enabled, room, onSessionEnded]);
}
